import { render, staticRenderFns } from "./AddArea.vue?vue&type=template&id=44add9d4"
import script from "./AddArea.vue?vue&type=script&lang=js"
export * from "./AddArea.vue?vue&type=script&lang=js"
import style0 from "./AddArea.vue?vue&type=style&index=0&id=44add9d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports